import Image from 'next/image';
import { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import cn from 'classnames';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { useModal } from '../../hooks';
import { IFormContact } from '../../components/form-contact';
import { sendMessage } from '../../services/contact.service';
import { Container, ContainerFluid, Feedback } from '../../components';
import { subscribeSchema } from '../../validation/submit.schema';
import styles from './fk-contact.module.css';

import woman from '../../public/fitkonnekt/contact/woman.png';
import logo from '../../public/fitkonnekt/contact/logo.png';

function FKContact() {
  const [mobile, setMobile] = useState<boolean>(false);
  const { setContent, open } = useModal();
  const resizeWindow = () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  useEffect(() => {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);
    return () => {
      window.removeEventListener('resize', resizeWindow);
    };
  }, []);

  const [disabled, setDisabled] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormContact>({
    mode: 'onBlur',
    resolver: yupResolver(subscribeSchema),
    defaultValues: {
      name: '',
      phone: '',
      email: '',
      message: '',
    },
  });

  const onSubmit = async (data: IFormContact) => {
    setDisabled(true);
    const response = await sendMessage(data);

    if (String(response.status).startsWith('2')) {
      setDisabled(false);
      setContent(<Feedback />);
      open();
      reset();
    }
  };

  return (
    <section className={styles.contact}>
      <ContainerFluid>
        <AnimationOnScroll
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          offset={400}
        >
          <h2 className={styles.contact_title}>
            Con<span>tact Us</span>
          </h2>
        </AnimationOnScroll>

        <Container>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
          >
            <div className={styles.wrapper_form}>
              <div className={styles.contact_form}>
                <h3 className={styles.contact_formTitle}>
                  Have a fitness project in mind? Drop us a line!
                </h3>
                <div
                  className={cn({
                    [styles.disabled]: disabled === true,
                  })}
                >
                  <div className={styles.input}>
                    <span className={styles.input_label}>Name</span>
                    <input
                      {...register('name')}
                      className={styles.input_elem}
                      placeholder="Your Name"
                    />
                    {!!errors?.name && (
                      <span className={styles.error}>
                        {errors.name?.message}
                      </span>
                    )}
                  </div>
                  <div className={styles.input}>
                    <span className={styles.input_label}>E-Male</span>
                    <input
                      {...register('email')}
                      className={styles.input_elem}
                      placeholder="Your Email"
                    />
                    {!!errors?.email && (
                      <span className={styles.error}>
                        {errors.email?.message}
                      </span>
                    )}
                  </div>
                  <div className={styles.input}>
                    <span className={styles.input_label}>Phone Number</span>
                    <InputMask
                      mask="+9999999999999"
                      maskPlaceholder={null}
                      {...register('phone')}
                      className={styles.input_elem}
                      placeholder="Your Number"
                    />
                    {!!errors?.phone && (
                      <span className={styles.error}>
                        {errors.phone?.message}
                      </span>
                    )}
                  </div>
                  <div className={styles.input}>
                    <span className={styles.input_label}>Message</span>
                    <input
                      {...register('message')}
                      className={styles.input_elem}
                      placeholder="Text Message"
                    />
                    {!!errors?.message && (
                      <span className={styles.error}>
                        {errors.message?.message}
                      </span>
                    )}
                  </div>
                  <div className={styles.wrapper}>
                    <button
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                      className={styles.button}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </AnimationOnScroll>
        </Container>
      </ContainerFluid>
      {!mobile && (
        <div className={styles.decort}>
          <ContainerFluid>
            <div className={styles.woman}>
              <AnimationOnScroll
                offset={400}
                animateOnce
                duration={1.2}
                animateIn="animate__fadeIn"
              >
                <Image alt="Fitkonnect banner" src={woman} />
              </AnimationOnScroll>
            </div>
            <Container className={styles.container_pos}>
              <div className={styles.logo}>
                <Image alt="Fitkonnect text logo" src={logo} />
              </div>
            </Container>
            <div className={styles.gradient} />
          </ContainerFluid>
          <div className={styles.lines} />
          <div className={styles.lines2} />
          <div className={styles.lines3} />
        </div>
      )}
    </section>
  );
}

export default FKContact;
